
<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    六约站<br>
站点介绍<br>
六约站位于深圳市龙岗区横岗街道深坑村龙岗大道中上方，东北侧为梧桐路、西北侧为深竹路、深坑路、东南侧为牛始埔路，车站沿龙岗大道方向大致呈东西走向布置，。A出入口周边：深圳地铁三号线运营分公司、横岗车辆段、六约山庄、牛始埔、六约社区、锦荟广场、大生体育公园；C出入口周边：振业城、梧桐花园、中海大山地、横岗高级中学、启航商务大厦、深坑村。此站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	05:58	23:25	3号线	2分15-20秒	4分30秒<br>
双龙	06:24	23:48	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:00	23:24	3号线	3分15秒	5分钟<br>
双龙	06:33	23:48	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:00	00:24	3号线	3分15秒	5分钟<br>
双龙	06:33	00:48	3号线	3分15秒	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
锦荟广场、大生体育公园、龙岗大道（东）、地铁集团运营总部客运三分公司、横岗车辆段、牛始埔、六约社区、和悦居<br><br>
C出入口:<br>
龙岗大道（西）、麟恒中心广场，振业城、梧桐花园、梧桐学校、中海大山地、振业城上观、瑞泽佳园、横岗高级中学、深坑社区、启航商务大厦<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 六约地铁站<br>
351,357,366,M229,M266,M268,M295,M309,M359,深惠3A，深惠3线，M180，M421,M547,M239、高快巴士20<br><br>
C出入口:<br>
公交站名： 六约地铁站<br>
61、351,357,366,M229,M266,M268,M295,M309,M359,深惠3A，深惠3线，M180，M421,M547,M239、高快巴士20，M324<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>
